import React, { memo, type ComponentPropsWithoutRef, forwardRef } from 'react';
import EditorAddIcon from '@atlaskit/icon/core/migration/add--editor-add';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { ThemedButton } from '@atlassian/jira-project-theme-components/src/ui/themed-button/ThemedButton.tsx';
import messages from './messages.tsx';

const AddTabTrigger = forwardRef<
	HTMLElement,
	ComponentPropsWithoutRef<typeof ThemedButton> & {
		noTooltip?: boolean;
		presentational?: boolean;
	}
>(({ presentational, noTooltip, ...props }, ref) => {
	const { formatMessage } = useIntl();
	const button = (
		<ThemedButton
			spacing="none"
			appearance="subtle"
			role={presentational ? 'presentation' : undefined}
			name={formatMessage(messages.addTabTriggerLabel)}
			ref={ref}
			{...props}
		>
			<EditorAddIcon
				LEGACY_size="medium"
				spacing="spacious"
				label={formatMessage(messages.addTabTriggerLabel)}
			/>
		</ThemedButton>
	);
	return (
		<Box xcss={boxStyles}>
			{noTooltip ? (
				button
			) : (
				<Tooltip content={formatMessage(messages.addTabTriggerLabel)} hideTooltipOnMouseDown>
					{button}
				</Tooltip>
			)}
		</Box>
	);
});

export default memo(AddTabTrigger);

const boxStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: '0',
	position: 'relative',
	alignSelf: 'center',
});
